import React, { useEffect, useState } from 'react';
import { Row, Col, Label, FormGroup, Input } from 'reactstrap';
import { DatePicker } from 'antd';
import 'antd/dist/antd.css';
import axios from 'axios';
import Select from 'react-select';
import Cookies from 'universal-cookie/cjs';
import moment from 'moment';
import SubmitButtons from './SubmitButtons';
import { changeTypeOptions, defaultDetails, defaultLPNChangeable } from './constants';

const cookies = new Cookies();

const DATE_FORMAT = 'YYYY-MM-DD';

function ChangeLpn({ id, back }) {
  const [details, setDetails] = useState(defaultDetails);
  const [lpnOptions, setLpnOptions] = useState([{ value: 'new', label: 'Add New' }]);
  const [registrationMark, setRegistrationMark] = useState('');
  const [LPNChangeable, setLPNChangeable] = useState(defaultLPNChangeable);
  const [isLoading, setIsLoading] = useState(true);

  async function checkLpnChange(lpn) {
    try {
      const { data: lpnChangebleData } = await axios.get(
        `${process.env.REACT_APP_API_DOMAIN}/booking-action/checkLpnChange/${id}`,
        {
          headers: { token: cookies.get('token') },
          params: {
            registrationMark: lpn,
          },
        }
      );

      setLPNChangeable(lpnChangebleData);
      return lpnChangebleData;
    } catch (error) {
      setLPNChangeable(defaultLPNChangeable);
      return {};
    }
  }

  async function fetchData() {
    const {
      data: { data: bookingData },
    } = await axios.get(`${process.env.REACT_APP_API_DOMAIN}/booking/${id}`, {
      headers: { token: cookies.get('token') },
    });

    const {
      CustomerId,
      ParkingPlan: { CarTypeId },
      CarParkId,
    } = bookingData;

    const { Car, validTo } = bookingData || {};
    const { registrationMark: currentRegistrationMark, id: currentCarId } = Car || {};

    await checkLpnChange(currentRegistrationMark);

    const car = {
      value: currentCarId,
      label: `${currentRegistrationMark} (current)`,
      isDisabled: true,
    };
    const changeType = { value: '', label: '' };

    setDetails({
      car,
      changeType,
      validFrom: moment().format(DATE_FORMAT),
      currentCar: { currentRegistrationMark, currentCarId },
      CarParkId,
      bookingValidTo: moment(validTo).format(DATE_FORMAT),
    });

    try {
      const {
        data: { data: carData },
      } = await axios.get(
        `${process.env.REACT_APP_API_DOMAIN}/car?CustomerId=${CustomerId}&CarTypeId=${CarTypeId}`,
        { headers: { token: cookies.get('token') } }
      );

      const allLpns = carData.map(({ id: carId, registrationMark }) => {
        if (carId === currentCarId) {
          return {
            value: carId,
            label: `${registrationMark} (current)`,
            isDisabled: true,
          };
        }
        return {
          value: carId,
          label: registrationMark,
        };
      });

      if (allLpns.findIndex(({ value }) => value === currentCarId) === -1) {
        allLpns.push({
          value: currentCarId,
          label: `${currentRegistrationMark} (current)`,
          isDisabled: true,
        });
      }

      lpnOptions.push(...allLpns);
      setLpnOptions(lpnOptions);
    } catch (err) {
      lpnOptions.push({
        label: `${currentRegistrationMark} (current)`,
        value: currentCarId,
        isDisabled: true,
      });
      setLpnOptions(lpnOptions);
    } finally {
      setIsLoading(false);
    }
  }

  const handleSelect = async (selected, type) => {
    if (type === 'car' && selected.value !== 'new') {
      setIsLoading(true);
      await checkLpnChange(selected.label);
      setIsLoading(false);
    }

    const data = { ...details, [type]: selected };

    if (type === 'changeType') {
      data.validTo =
        selected.value === 'temporary'
          ? moment(details.validFrom, DATE_FORMAT).add(5, 'days').format(DATE_FORMAT)
          : moment(details.bookingValidTo).format(DATE_FORMAT);
    }

    setDetails(data);
  };

  const bodyData = () => {
    const { car, changeType, validFrom, currentCar, validTo, CarParkId } = details;
    const { value: CarId, label: newRegistrationMark } = car || {};
    const { value: changeTypeValue } = changeType || {};

    if (CarId === 'new') {
      return {
        origin: 'cms',
        newCarPlate: registrationMark,
        type: changeTypeValue,
        validFrom,
        validTo,
        PreviousBookingId: id,
        PreviousCarId: currentCar?.currentCarId,
        previousCarPlate: currentCar?.currentRegistrationMark,
        status: 'accepted',
        amount: changeTypeValue === 'temporary' ? 0 : 50,
        CarParkId,
      };
    }

    return {
      origin: 'cms',
      newCarPlate: newRegistrationMark.replace(' (current)', ''),
      NewCarId: CarId,
      type: changeTypeValue,
      validFrom,
      validTo,
      PreviousBookingId: id,
      PreviousCarId: currentCar?.currentCarId,
      previousCarPlate: currentCar?.currentRegistrationMark,
      status: 'accepted',
      amount: changeTypeValue === 'temporary' ? 0 : 50,
      CarParkId,
    };
  };

  async function onSave(url, body) {
    setIsLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_DOMAIN}/CarPlateChange`, body, {
        headers: { token: cookies.get('token') },
      });
      setIsLoading(false);
      if (!alert('Record successfully updated')) {
        window.location.reload();
      }
    } catch (e) {
      const { response = {} } = e || {};
      const { data = {} } = response || {};
      const { error = '' } = data || {};
      setIsLoading(false);
      if (error && error === 'User already have a confirmed waiting') {
        alert('Duplicate Records.');
        return;
      }

      alert(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <Row>
        <Col md={6} className="mb-4">
          <FormGroup>
            <Label>Car</Label>
            <Select
              menuPlacement="auto"
              menuPosition="fixed"
              options={lpnOptions}
              value={details.car}
              onChange={(selected) => {
                handleSelect(selected, 'car');
              }}
              isOptionDisabled={(option) => option.isDisabled}
            />
            {details.car.value === 'new' && (
              <Input
                type="text"
                className="mt-2"
                name={details.car}
                value={registrationMark}
                onChange={(e) => setRegistrationMark(e.target.value)}
                onBlur={() => {
                  if (registrationMark) {
                    checkLpnChange(registrationMark);
                  }
                }}
              />
            )}
          </FormGroup>
        </Col>
        <Col md={6} className="mb-4">
          <FormGroup>
            <Label>Type of Change</Label>
            <Select
              menuPlacement="auto"
              menuPosition="fixed"
              options={changeTypeOptions}
              value={details.changeType}
              onChange={(selected) => handleSelect(selected, 'changeType')}
            />
          </FormGroup>
        </Col>
        <Col md={6} className="mb-4">
          <div className="d-flex flex-column">
            <Label>Valid From</Label>
            <DatePicker
              disabled
              className="mb-4"
              value={moment(details.validFrom)}
              onChange={(date, dateString) => setDetails({ ...details, validFrom: dateString })}
            />
          </div>
        </Col>
        {details?.changeType?.value === 'temporary' && (
          <Col md={6} className="mb-4">
            <div className="d-flex flex-column">
              <Label>Valid To</Label>
              <DatePicker
                className="mb-4"
                value={moment(details.validTo)}
                onChange={(date, dateString) => setDetails({ ...details, validTo: dateString })}
                disabledDate={(current) =>
                  current.isBefore(moment(), 'day') ||
                  current.isAfter(moment().add(5, 'days'), 'day')
                }
              />
            </div>
          </Col>
        )}
      </Row>

      {LPNChangeable?.vehicleIsPresent && <p style={{ color: 'red' }}>vehicle is present</p>}
      {details?.changeType?.value === 'temporary' && !LPNChangeable.isTempChangeable && (
        <p style={{ color: 'red' }}>Temporary change is not allowed</p>
      )}
      {details?.changeType?.value === 'permanent' && !LPNChangeable.isPermanentChangeable && (
        <p style={{ color: 'red' }}>Permanent change is not allowed</p>
      )}

      <SubmitButtons
        id={id}
        back={back}
        body={bodyData()}
        onClick={(url, data) => onSave(url, data)}
        disabled={
          (!LPNChangeable.isTempChangeable && !LPNChangeable.isPermanentChangeable) ||
          (details?.changeType?.value === 'temporary' && !LPNChangeable.isTempChangeable) ||
          (details?.changeType?.value === 'permanent' && !LPNChangeable.isPermanentChangeable) ||
          LPNChangeable?.vehicleIsPresent ||
          isLoading
        }
      />
    </div>
  );
}

export default ChangeLpn;
